import React, { useEffect, useState } from 'react';
import sleep from '../../utils/sleep';

const SlicingTextList = ({ list }) => {


    const [sliceText, setSliceText] = useState('');
    const [typingIntervalID, setTypingIntervalID] = useState<NodeJS.Timeout>();

    useEffect(() => {

        let listIndex = 0;
        let textIndex = 0;
        let awaitTime = 0;

        const tID = setInterval(() => {

            if (textIndex >= list[listIndex].length) {
                awaitTime += 1;
                if (awaitTime > 8) {
                    textIndex = 0;
                    listIndex = listIndex + 1 >= list?.length ? 0 : listIndex + 1;
                    awaitTime = 0;
                }

            }
            else {
                textIndex += 1;
            }

            setSliceText(list[listIndex].slice(0, textIndex));


        }, 100);
        setTypingIntervalID(tID);

        return () => clearInterval(tID);
    }, []);




    return <div style={{ width: '100%', minHeight: '50px' }}><h2 style={{ color: '#00ffff', fontSize: '24px' }}>{sliceText} </h2></div>


}

export default SlicingTextList;